import { FOOTER } from '@/constants/footer';
import BrandDefinition from '@/types/BrandDefinition';
import FooterDictionary from '@/types/dictionaries/Footer';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { SxProps } from '@mui/material/styles';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';

const styles = {
	box: {
		display: 'flex',
		alignItems: 'center',
		flex: '1 0 0',
		gap: '4px',
	},
	icon: {
		height: '18px',
		width: '18px',
		color: 'grey.light',
	},
	link: {
		fontWeight: 400,
		color: 'white.main',
		':hover': {
			fontWeight: 400,
			color: 'grey.light',
		},
	},
} as const satisfies Record<string, SxProps>;

interface ExternalLinksSectionProps {
	dict: FooterDictionary;
	brand: BrandDefinition;
	showHeading: boolean;
}

export default function ExternalLinksSection({ dict, brand, showHeading }: Readonly<ExternalLinksSectionProps>) {
	const footerConstants = FOOTER[brand.brandCode];

	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', rowGap: '8px' }} data-testid="footer-external-links">
			{showHeading && (
				<Typography variant="paragraphExtraBold" data-testid="footer-external-links-title">
					{dict.externalLinksSection.title}
				</Typography>
			)}
			<Box sx={{ ...styles.box }} data-testid="footer-company-website-link">
				<Link target="_blank" href={footerConstants.website} sx={{ ...styles.link }}>
					{`${footerConstants.companyName} ${dict.externalLinksSection.companyWebsite}`}
				</Link>
				<OpenInNewOutlinedIcon sx={{ ...styles.icon }} />
			</Box>
			<Box sx={{ ...styles.box }} data-testid="footer-download-center-link">
				<Link target="_blank" href={footerConstants.downloadCenter} sx={{ ...styles.link }}>
					{dict.externalLinksSection.downloadCenter}
				</Link>
				<OpenInNewOutlinedIcon sx={{ ...styles.icon }} />
			</Box>
		</Box>
	);
}
